export const maxFileSize = 15;

export const maxTotalFilesSize = 15;

export const maxNumberOfFiles = 5;

export const columnGridCount = 12;

export const allowedMimeTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/x-png',
    'image/jpe',
    'image/jpg',
    'image/jpeg',
    'image/png',
];

export const PRODUCT_TRANSLATION_KEYS = [
    'contact_form.contact.product.select_option.paysera_pos',
    'contact_form.contact.product.select_option.paysera_checkout',
    'contact_form.contact.product.select_option.paysera_tickets',
    'contact_form.contact.product.select_option.mass_payments_via_api',
    'contact_form.contact.product.select_option.self_service_terminal',
    'contact_form.contact.product.select_option.peer_to_peer_lending',
    'contact_form.contact.product.select_option.other',
];

// Mirrors the server's `subject` Length constraint (Resources/config/validation.xml).
export const SUBJECT_MAX_LENGTH = 73;

export const VALIDATION_LIMITS = {
    NAME_MIN_LENGTH: 2,
    NAME_MAX_LENGTH: 54,
    COMPANY_NAME_MIN_LENGTH: 2,
    COMPANY_NAME_MAX_LENGTH: 100,
    // Keeps `SUPPORT_SUBJECT_BASE - {clientId}` within SUBJECT_MAX_LENGTH (27-char prefix + 46).
    CLIENT_ID_MAX_LENGTH: 46,
    MESSAGE_MIN_LENGTH: 5,
    MESSAGE_MAX_LENGTH: 5000,
};

export const FIELD_NAMES = {
    name: 'name',
    email: 'email',
    companyName: 'companyName',
    clientId: 'clientId',
    product: 'product',
    message: 'message',
    attachments: 'attachments',
};

export const VALIDATION_RULES = {
    required: 'required',
    minLength: 'minLength',
    maxLength: 'maxLength',
    email: 'email',
};

export const VALIDATION_ERROR_KEYS = {
    required: 'contact_form.validate.required',
    emailNotValid: 'contact_form.validate.email_not_valid',
    short: (length) => `contact_form.validate.short_${length}`,
    long: (length) => `contact_form.validate.long_${length}`,
};

export const toCharacters = value => Array.from(value);

export const RULES = {
    [VALIDATION_RULES.required]: (value) => {
        if (!value || !value.trim()) {
            return VALIDATION_ERROR_KEYS.required;
        }

        return null;
    },

    [VALIDATION_RULES.minLength]: (value, minLength) => {
        if (value && toCharacters(value.trim()).length < minLength) {
            return VALIDATION_ERROR_KEYS.short(minLength);
        }

        return null;
    },

    [VALIDATION_RULES.maxLength]: (value, maxLength) => {
        if (value && toCharacters(value.trim()).length > maxLength) {
            return VALIDATION_ERROR_KEYS.long(maxLength);
        }

        return null;
    },

    [VALIDATION_RULES.email]: (value) => {
        if (!value?.trim() || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
            return VALIDATION_ERROR_KEYS.emailNotValid;
        }

        return null;
    },
};

const SHARED_VALIDATION_SCHEMA = {
    [FIELD_NAMES.email]: [
        { rule: VALIDATION_RULES.required },
        { rule: VALIDATION_RULES.email },
    ],
    [FIELD_NAMES.message]: [
        { rule: VALIDATION_RULES.required },
        { rule: VALIDATION_RULES.minLength, value: VALIDATION_LIMITS.MESSAGE_MIN_LENGTH },
        { rule: VALIDATION_RULES.maxLength, value: VALIDATION_LIMITS.MESSAGE_MAX_LENGTH },
    ],
};

export const BUSINESS_DEVELOPMENT_VALIDATION_SCHEMA = {
    ...SHARED_VALIDATION_SCHEMA,
    [FIELD_NAMES.companyName]: [
        { rule: VALIDATION_RULES.required },
        { rule: VALIDATION_RULES.minLength, value: VALIDATION_LIMITS.COMPANY_NAME_MIN_LENGTH },
        { rule: VALIDATION_RULES.maxLength, value: VALIDATION_LIMITS.COMPANY_NAME_MAX_LENGTH },
    ],
    [FIELD_NAMES.product]: [
        { rule: VALIDATION_RULES.required },
    ],
};

export const SUPPORT_VALIDATION_SCHEMA = {
    ...SHARED_VALIDATION_SCHEMA,
    [FIELD_NAMES.name]: [
        { rule: VALIDATION_RULES.required },
        { rule: VALIDATION_RULES.minLength, value: VALIDATION_LIMITS.NAME_MIN_LENGTH },
        { rule: VALIDATION_RULES.maxLength, value: VALIDATION_LIMITS.NAME_MAX_LENGTH },
    ],
    [FIELD_NAMES.clientId]: [
        { rule: VALIDATION_RULES.maxLength, value: VALIDATION_LIMITS.CLIENT_ID_MAX_LENGTH },
    ],
};

export const RECIPIENTS = {
    support: 'support',
    businessDevelopment: 'business_development',
};

export const RENDERED_FIELDS = {
    [RECIPIENTS.support]: [
        FIELD_NAMES.name,
        FIELD_NAMES.email,
        FIELD_NAMES.clientId,
        FIELD_NAMES.message,
        FIELD_NAMES.attachments,
    ],
    [RECIPIENTS.businessDevelopment]: [
        FIELD_NAMES.email,
        FIELD_NAMES.companyName,
        FIELD_NAMES.product,
        FIELD_NAMES.message,
        FIELD_NAMES.attachments,
    ],
};

export const SUPPORT_SUBJECT_BASE = 'Customer support request';

export const BUSINESS_DEVELOPMENT_SUBJECT_BASE = 'Business service request';
